<template>
  <ThemeProvider>
    <AppBase class="app" fill scrollable google-analytics-id="GTM-P9FQ5FR">
      <template>
        <div class="airdrop-crates">
          <div
            :style="{ backgroundImage: `url(${airdropImage})` }"
            class="crate-1"
          />
          <div
            :style="{ backgroundImage: `url(${airdropImage})` }"
            class="crate-2"
          />
          <div
            :style="{ backgroundImage: `url(${airdropImage})` }"
            class="crate-3"
          />
          <div
            :style="{ backgroundImage: `url(${airdropImage})` }"
            class="crate-4"
          />
        </div>
        <Flex grow direction="column">
          <BlockHeader />
          <FlexItem>
            <main>
              <transition name="fade"> <router-view /> </transition>
            </main>
          </FlexItem>
        </Flex>
      </template>
      <Background
        :image="require('./assets/images/background-waves.svg')"
        class="background-waves"
      />
    </AppBase>
  </ThemeProvider>
</template>

<script>
import {
  AppBase,
  Background,
  ButtonBase,
  Flex,
  FlexItem,
  Modal,
  ThemeProvider,
  SpinnerOverlay,
} from '@nauticus-blockchain/nauticus-ui'
import BlockHeader from './components/blocks/B1_Header'
import Main from '@/components/Main'

export default {
  name: 'App',
  components: {
    AppBase,
    Background,
    ButtonBase,
    BlockHeader,
    Flex,
    FlexItem,
    Modal,
    ThemeProvider,
    SpinnerOverlay,
    Main,
  },
  computed: {
    airdropImage() {
      return require('@/assets/images/airdrop.png')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@nauticus-blockchain/nauticus-ui/src/assets/styles/mixins';

a {
  color: #3a99fc;
}

.background-waves {
  z-index: -2;
}

.airdrop-crates > div {
  background-repeat: no-repeat;
  background-size: contain;
  position: fixed;
  transform-origin: 50% 50%;
  z-index: -1;
}
.crate-1 {
  width: 26vw;
  height: 26vw;
  left: 10vw;
  top: -17vh;
  opacity: 0.9;
}
.crate-2 {
  width: 26vw;
  height: 26vw;
  left: 70vw;
  top: -42vh;
  transform: scaleX(-1) rotate(10deg);
  opacity: 0.8;
}
.crate-3 {
  width: 13vw;
  height: 13vw;
  left: 68vw;
  top: 40vh;
  transform: scaleX(-1);
  opacity: 0.6;
}
.crate-4 {
  width: 6vw;
  height: 6vw;
  left: 40vw;
  top: 70vh;
  opacity: 0.3;
  transform: rotate(10deg);
}
@media (max-width: 1800px) {
  .crate-1 {
    left: 10vw;
    top: -10vh;
  }
  .crate-3 {
    width: 20vw;
    height: 20vw;
  }
  .crate-4 {
    width: 8vw;
    height: 8vw;
  }
}
@media (max-width: 1300px) {
  .crate-1 {
    left: 10vw;
    top: 0vh;
  }
  .crate-3 {
    width: 23vw;
    height: 23vw;
  }
  .crate-4 {
    width: 10vw;
    height: 10vw;
  }
}
@media (max-width: 850px) {
  .crate-1 {
    top: 12vh;
  }
  .crate-3 {
    width: 23vw;
    height: 23vw;
  }
  .crate-4 {
    width: 12vw;
    height: 12vw;
  }
}

@include transitionFade;
</style>
